import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@ngneat/transloco';
import { AutoCompleteModule } from 'primeng/autocomplete';

import { CallListAutocompleteComponent } from './call-list-autocomplete.component';

@NgModule({
  declarations: [CallListAutocompleteComponent],
  imports: [AutoCompleteModule, CommonModule, MatIconModule, ReactiveFormsModule, TranslocoModule],
  exports: [CallListAutocompleteComponent],
})
export class CallListAutocompleteModule {}
